module.exports = __webpack_public_path__ + "static/assets/fd74f06235f39845eb527e41487f0bdd.png";